import { Candle, Security } from '../../proto/generated/candle-data-depot-common'
import { CandleChange } from './candleChangeManager'

export const getCandleChange = (prev: Candle | undefined, current: Candle, security: Security): CandleChange => {
    return {
        startTimestamp: current.startTimestamp,
        security,
        ltp: current.close,
        ltpChange: current.close - (prev?.close ?? 0),
        ltpChangePercent: prev?.close ? ((current.close - (prev?.close ?? 0)) / (prev?.close ? prev?.close : 1)) * 100 : 0,
        impliedVolatility: current.impliedVolatility * 100,
        optionGreeks: current.optionGreeks,
        topBid: current.topBid,
        topAsk: current.topAsk,
        openInterest: current.openInterest,
        oiChange: current.openInterest - (prev?.openInterest ?? 0),
        volume: current.volume,
        deliveryPercentage: current.deliveryPercentage
    }
}